import { Pipe, PipeTransform } from '@angular/core';
import { BmsDataExportValueStatus } from '../../models/bms-data-export-value';

@Pipe({
  name: 'bmsdataexportvaluestatuspipe'
})
export class BmsDataExportValueStatusPipe implements PipeTransform {

  transform(status: BmsDataExportValueStatus, defaultResult : string): string {

    let result: string[] = [];
    if (status & BmsDataExportValueStatus.AutomaticEstimate) {
      result.push('AUT_EST');
    }
    if (status & BmsDataExportValueStatus.ManualEstimate) {
      result.push('MAN_EST');
    }
    if (status & BmsDataExportValueStatus.ResidentExchange) {
      result.push('RES_EX');
    }
    if (status & BmsDataExportValueStatus.MissingEndValue) {
      result.push('NO_END');
    }
    if (status & BmsDataExportValueStatus.MissingStartValue) {
      result.push('NO_START');
    }
    if (status & BmsDataExportValueStatus.MissingPrevEndValue) {
      result.push('NO_PRE_END');
    }
    if (status & BmsDataExportValueStatus.MissingTariff) {
      result.push('NO_TAR');
    }
    if (status & BmsDataExportValueStatus.Error) {
      result.push('ERROR');
    }
    if (status & BmsDataExportValueStatus.Warning) {
      result.push('WARN');
    }
    if (status & BmsDataExportValueStatus.Signed) {
      result.push('SIGNED');
    }
    if (status & BmsDataExportValueStatus.Invoiced) {
      result.push('INVOICED');
    }
    if (status & BmsDataExportValueStatus.NegativeConsumption) {
      result.push('NEG');
    }
    if (status & BmsDataExportValueStatus.HighConsumption) {
      result.push('HIGH');
    }
    if (status & BmsDataExportValueStatus.ExceedinglyHigh) {
      result.push('EX_HIGH');
    }
    if (status & BmsDataExportValueStatus.LowConsumption) {
      result.push('LOW');
    }
    if (status & BmsDataExportValueStatus.ZeroConsumption) {
      result.push('ZERO');
    }
    // if (status & BmsDataExportValueStatus.HasComment) {
    //   result.push('COMM');
    // }

    return result.length == 0 ? defaultResult : result.join(',');
  }

}
